module.exports = __webpack_public_path__ + "media/f3.a8f2105c.mp3";